import { apm as rum, init } from '@elastic/apm-rum'

export function initRum() {
  const appName = process.env.APP || 'pa-front-local'
  const options = {
    serviceName: `rum-${appName}`,
    serverUrl: process.env.NEXT_PUBLIC_ELASTIC_APM_SERVER_URL,
    environment:
      process.env.NEXT_PUBLIC_ELASTIC_APM_ENVIRONMENT || 'development',
    active: process.env.NEXT_PUBLIC_ELASTIC_APM_ACTIVE === 'true',
    distributedTracingOrigins: [process.env.NEXT_PUBLIC_API_ENDPOINT || ''],
  }

  init(options)
}

export function captureError(error: Error | string) {
  if (globalThis.window === undefined) {
    import('elastic-apm-node').then((apm) => apm.default.captureError(error))
  } else {
    rum.captureError(error)
  }
}
